import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { Category, Report } from '../../../../documents';
export const UPLOAD_DLG_DATA_TOKEN = new InjectionToken('UPLOAD_DLG_DATA_TOKEN');

export interface UploadDialogData<T extends Report | void> {
    subCategories$?: Observable<Category[]>;
    category: Category;
    report?: T;
}